import React from 'react';

export const Organisasjon = () => {
  return (
    <>
      Organisasjon page
      {/* <EnhancedTable /> */}
    </>
  )
}